import {combineReducers} from '@reduxjs/toolkit';

import {assignAccountEntitlementsReducer} from '../tabs/assign-entilements';
import {assignProductAccountEntitlementsReducer} from '../tabs/assign-product-entilements';

import {accountPageSlice} from './account-page-slice';
import {accountPageTabsReducer} from './account-page-tabs-reducer';

export const accountPageReducer = combineReducers({
    details: accountPageSlice.reducer,
    tabs: accountPageTabsReducer,
    assignEntitlements: assignAccountEntitlementsReducer,
    assignProductEntitlements: assignProductAccountEntitlementsReducer,
});
